let env = ''
if (process.env.NODE_ENV === 'development') {
  env = 'dev' // 本地开发环境
} else if (process.env.NODE_ENV === 'test') {
  env = 'test' // test环境
} else if (process.env.NODE_ENV === 'production') {
  env = 'production' // 正式环境
}
console.log('=======env=======', env);

const baseURL = {
  dev: 'api',
  test: 'http://121.42.175.177:8787/API/api', // 测试
  staging: 'http://119.23.59.186:8877/API/api', // 预发布
  production: 'https://cdp.yunjichaobiao.com/API/api', // 生产
}
const orderURL = {
  dev: 'order',
  test: 'http://121.42.175.177:8501/api', // test 环境
  staging: 'https://c3.jisheyun.com/service/orderapi/api', // 预发布
  production: 'https://c3.jisheyun.com/service/orderapi/api', // 生产
}
module.exports = {
  title: '能源管理系统',
  imgUrl: 'http://121.42.175.177:8787/api/',
  url:  baseURL[env],
  // url: 'http://121.42.175.177:8787/API/api',  // 测试
  // url: 'http://119.23.59.186:8877/API/api',
  // url: 'http://119.23.59.186:18996/API/api', // 正式
  // url: 'http://119.23.59.186:19889/api',  // 预发布
  getFile: '/Download/GetFile',
  orderApi: orderURL[env],
  qrcodeURL:process.env.NODE_ENV !== 'production' ? 'http://yytest.jisheyun.com' : 'https://c3.jisheyun.com',
  // qrcodeURL: 'http://yytest.jisheyun.com',
}
